import { useMainStore } from '../../store/mainStore';

export const useConfirmation = () => {
  const setConfirmationData = useMainStore((state) => state.setConfirmationModalData);
  return setConfirmationData;
};
